module.exports = __webpack_public_path__ + "static/media/0302.2a9297bf.png";